<template>
    <transition name="fade">
        <div class="page_processing_modal" v-if="getIsDTSupportModalOpen">
            <div class="page_processing_card">
                <div class="text-white">
                    <h2>
                        Experiencing any delay? <br>
                        <span>Contact support</span>
                    </h2>

                    <button
                        type="button"
                        @click.prevent="openWhatsapp"
                        class="btn--big--round button"
                    >
                        <img src="@/assets/img/services/whatsapp.png" width="18" height="18" alt="whatsapp" />
                        Contact us
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    computed: {
        ...mapGetters(["getIsDTSupportModalOpen"]),
    },
    methods: {
        openWhatsapp() {
            const ref = this.$route.query.transactioncode;
            if (ref) {
                let url = `whatsapp://send?phone=+2349127287158&text=Transaction%20code:%20${ref}.`;
                window.open(url);
            }
        },
    },
    // mounted() {
    //     console.log(this.$route.query.transactioncode);
    // },
};
</script>

<style scoped>
.page_processing_modal {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    height: 100% !important;
    background: rgba(94, 99, 95, 0.2);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    display: flex;
    flex-direction: column;
    -ms-flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    z-index: 110009 !important;
    transition: 400ms ease;
    -o-transition: 400ms ease;
    -moz-transition: 400ms ease;
    -webkit-transition: 400ms ease;
}

.page_processing_card {
    position: relative;
    width: 100%;
    max-width: 600px;
    height: auto;
    min-height: 180px;
    padding: 40px 20px;
    display: flex;
    flex-direction: column;
    -ms-flex-direction: column;
    justify-content: center;
    align-items: center;
    background: linear-gradient(to bottom right, var(--black2), var(--black2));
    box-shadow: 3px 6px 10px 0 rgb(0 102 245 / 7%);
    border-radius: 16px;
    text-align: center;
}

.page_processing_card h2 {
    font-weight: medium !important;
    font-size: 24px;
}

.page_processing_card .button {
    width: 100%;
    max-width: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    font-weight: normal !important;
    padding: 8px 16px;
    margin: 30px auto 0;
    color: #f7f7f7;
    cursor: pointer;
}
.page_processing_card .button img,
.page_processing_card .button:hover {
    opacity: 0.75;
}

@media screen and (max-width: 350px) {
    .page_processing_card {
        width: 95%;
        margin: auto;
    }
}
</style>
